const stylesCall = {
  stackb: {
    width: "50%",
    flexGrow: 1,
  },
  stackc: {
    display: "block",
    color: "#606060",
    fontWeight: "600",
  },
  link: {
    cursor: "pointer",
    color: "#606060",
    fontSize: "1.5rem",
    fontFamily:"Candara"
  },
  typography: {
    margin: "2% 0 2%",
    marginTop:"1.5rem",
    fontFamily: "Raleway,sans-serif"
  },
  file: {
    maxWidth: "50%",
    width:"30%"
  },
  stackd: {
    marginTop: "2rem",
  },
  typographyc: {
    color: "#606060",
    paddingRight: "10px",
    fontSize: "1.5rem",
    fontFamily: "Raleway,sans-serif"
  },
  stacke: {
    border: "1px solid #d3d3d3",
    marginTop: "1rem",
    borderRadius: "1rem",
  },
  stackf: {
    margin: "1rem",
    marginTop:"2rem",
  },
  stackh: {
    width: "50%",
  },
  typographyd: {
    textAlign: "left",
    color: "black",
    opacity: "0.7",
    fontWeight: "bold",
    fontFamily: "Raleway,sans-serif"
  },
  typographye: {
    margin: "2% 0",
    fontFamily: "Raleway,sans-serif"
  },
};

export default stylesCall;
